import { memo, useMemo, type FC } from "react";
import { useTranslation } from "react-i18next";
import type { CampaignChannel } from "src/layouts/Engagements/EngagementInterfaces";
import { CAMPAIGN_CHANNEL_OPTIONS } from "src/layouts/Engagements/Campaigns/CampaignSetup/CampaignSetupConstants";
import ChatChoiceStep from "./ChatChoiceStep";
import { CHANNEL_QUESTION_KEY } from "./ChatCampaignChoiceConstants";

interface ChatChannelChoiceProps {
  onSelect: (_channel: CampaignChannel) => void;
  isAnswered: boolean;
}

const ChatChannelChoice: FC<ChatChannelChoiceProps> = ({ onSelect, isAnswered }) => {
  const { t } = useTranslation();
  const options = useMemo(
    () => CAMPAIGN_CHANNEL_OPTIONS.map(({ value, labelKey }) => ({ value, label: t(labelKey) })),
    [t]
  );

  return (
    <ChatChoiceStep
      question={t(CHANNEL_QUESTION_KEY)}
      options={options}
      onSelect={onSelect}
      isAnswered={isAnswered}
    />
  );
};

export default memo(ChatChannelChoice);
